<template>
    <template v-for="banner in banners">
        <PluginTrialBanner
            v-if="banner.key === 'plugin-trial-active'"
            :key="banner.key"
            class="sticky z-20 top-14 md:relative md:top-0"
            :date="banner.date ?? undefined"
        />

        <TrialEndedBanner
            v-else-if="banner.key === 'plugin-trial-ended'"
            :key="banner.key"
            class="sticky z-20 top-14 md:relative md:top-0"
            :date="banner.date ?? undefined"
            type="plugin"
        />

        <TrialEndedBanner
            v-else-if="banner.key === 'pro-trial-ended'"
            :key="banner.key"
            class="sticky z-20 top-14 md:relative md:top-0"
            :date="banner.date ?? undefined"
            type="pro"
        />

        <SubscriptionBanner
            v-else-if="banner.key === 'plugin-subscription-lapsed'"
            :key="banner.key"
            class="sticky z-20 top-14 md:relative md:top-0"
            type="plugin"
        />

        <SubscriptionBanner
            v-else-if="banner.key === 'pro-personal-subscription'"
            :key="banner.key"
            class="sticky z-20 top-14 md:relative md:top-0"
            type="pro-personal"
        />

        <SubscriptionBanner
            v-else-if="banner.key === 'pro-team-subscription'"
            :key="banner.key"
            class="sticky z-20 top-14 md:relative md:top-0"
            type="pro-team"
        />

        <InfoBanner
            v-else-if="banner.key === 'account-deleted'"
            :key="banner.key"
            show
            class="sticky z-20 top-14 md:relative md:top-0"
            title="Your templates have been removed due to prolonged inactivity, and your profile is scheduled for permanent deletion in 30 days"
        >
            For more information on how to restore them, please contact our
            support team at support@topol.io.
        </InfoBanner>

        <InfoBanner
            v-else-if="
                banner.key === 'payment-request-due' && banner.paymentRequest
            "
            :key="banner.key"
            show
            class="sticky z-20 top-14 md:relative md:top-0"
            :title="
                'Your payment for ' +
                banner.paymentRequest.name +
                ' is due soon'
            "
        >
            Please complete your payment of ${{
                banner.paymentRequest.formattedTotal
            }}
            by
            {{
                format(
                    new Date(banner.paymentRequest.due_date),
                    'd MMMM, yyyy'
                )
            }}
            to avoid any service issues.

            <inertia-link
                :href="
                    route('payment-requests.show', banner.paymentRequest.uuid)
                "
                class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                >Click here to proceed.</inertia-link
            >
        </InfoBanner>

        <InfoBanner
            v-else-if="banner.key === 'team-storage-blocked'"
            :key="banner.key"
            show
            :dismissible="banner.dismissible"
            class="sticky z-20 top-14 md:relative md:top-0"
            title="Your PRO storage has been blocked. You won't be able to use images in your templates."
            @dismiss="dismissBanner(banner)"
        >
            For more information on how to unblock it, please contact our
            support team at support@topol.io.
        </InfoBanner>

        <InfoBanner
            v-else-if="banner.key === 'api-token-storage-blocked'"
            :key="banner.key"
            show
            :dismissible="banner.dismissible"
            class="sticky z-20 top-14 md:relative md:top-0"
            title="Your Plugin storage has been blocked for at least one of your API tokens."
            @dismiss="dismissBanner(banner)"
        >
            For more information on how to unblock it, please contact our
            support team at support@topol.io.
        </InfoBanner>
    </template>
</template>

<script lang="ts" setup>
import { format } from 'date-fns';
import { route } from 'ziggy-js';
import useBanners from '@/composables/useBanners';
import InfoBanner from '@components/Navigation/components/InfoBanner.vue';
import PluginTrialBanner from '@components/Navigation/components/PluginTrialBanner.vue';
import SubscriptionBanner from '@components/Navigation/components/SubscriptionBanner.vue';
import TrialEndedBanner from '@components/Navigation/components/TrialEndedBanner.vue';

const { banners, dismissBanner } = useBanners();
</script>
